export default {
  benefits: {
    earn_points: 'Verdien punten bij elke bestelling',
    get_deals: 'Ontvang exclusieve kortingen',
    redeem_points: 'Wissel punten in voor gratis eten',
  },
};
